<template>
  <LegacyPageContent v-if="hasProfile">
    <Greetings
      :title="`My profile`"
      :show-info-icon="true"
      @infoIconClick="handleInfoIconClick"
    />
    <Header :user="profile" />
    <!-- <ContactPreferences :user="profile" /> -->
    <Progress />
    <About :user="profile" />
    <br />
    <Preferences :user="profile" />
    <br />
    <UserSubscriptions />
    <v-divider />
    <MyConnections :link-to-connections="true" />
    <UserReferralsNumber
      title="Referred Connections"
      :user="profile"
      v-trackEvent:viewReferralsClicked="{
        event: 'referred_connections_tap'
      }"
    />

    <InfoDialog
      title="This is your professional profile!"
      :show.sync="showInfoDialog"
    >
      <div>
        <p>
          Upload your CV and complete your profile to maximise your opportunities across the Riverflex network.
        </p>
        <p>
          Adding your CV and LinkedIn URL significantly increases your chances of being invited to join the Riverflex Insider group.
        </p>
      </div>
    </InfoDialog>
  </LegacyPageContent>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'

import Greetings from '@/components/core/Greetings.vue'
import Header from '@/components/profile/Header.vue'
import Progress from '@/components/profile/Progress.vue'
import About from '@/components/profile/About.vue'
import Preferences from '@/components/profile/Preferences.vue'
import MyConnections from '@/components/profile/MyConnections.vue'
// import ContactPreferences from '@/components/profile/ContactPreferences.vue'
import UserSubscriptions from '@/components/profile/UserSubscriptions.vue'
import InfoDialog from '@/components/core/InfoDialog.vue'
import UserReferralsNumber from '@/components/profile/UserReferralsNumber.vue'
import LegacyPageContent from '@/components/layouts/LegacyPageContent.vue'

import ShowInfoDialogMixin, { IShowDialogMixin } from '@/mixins/ShowInfoDialog.mixin'
import { IUser } from '@/types/models/user.model'
import { trackHelpBtnTap } from '@/segmentAnalytics/common'

@Component({
  components: {
    Greetings,
    Header,
    Progress,
    About,
    Preferences,
    MyConnections,
    UserSubscriptions,
    InfoDialog,
    UserReferralsNumber,
    LegacyPageContent
    // ContactPreferences
  },
  computed: {
    ...mapGetters(['profile'])
  }
})
export default class Profile extends Mixins(ShowInfoDialogMixin) implements IShowDialogMixin {
  @Prop() hasProfile: boolean

  // data
  pageName: string = 'profile'
  showInfoDialog: boolean = false

  // computed
  // mapGetters
  profile: IUser|null

  // lifecycle hooks
  beforeDestroy () {
    this.$store.dispatch('sendProfileUpdateStats')
  }

  handleInfoIconClick () {
    trackHelpBtnTap('profile')
    this.showInfoDialog = true
  }
}
</script>
